export enum SidewallSoffitType {
  Angled = 'angled', // bottom of sidewall soffit parallel with sidewall roof surface
  FlatToRoofEdge = 'flatToRoofEdge', // bottom of sidewall soffit parallel to ground and extends to gable end roof edge
  FlatToWall = 'flatToWall', // bottom of sidewall soffit parallel to ground and stop at gable end walls
  None = 'none', // do not draw soffit
}
